import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    logoUrl: String
  }

  connect() {
    // Écouter quand Turbo commence à charger le frame
    this.element.addEventListener("turbo:before-fetch-request", this.showSpinner.bind(this))

    // Écouter quand le frame est chargé (pour cacher le spinner si besoin)
    this.element.addEventListener("turbo:frame-load", this.hideSpinner.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-fetch-request", this.showSpinner.bind(this))
    this.element.removeEventListener("turbo:frame-load", this.hideSpinner.bind(this))
  }

  showSpinner(event) {
    // Injecter le HTML du spinner dans le turbo-frame
    const spinnerHTML = this.getSpinnerHTML()
    this.element.innerHTML = spinnerHTML
  }

  hideSpinner(event) {
    // Le spinner sera automatiquement remplacé par le contenu chargé
    // Pas besoin de faire quoi que ce soit ici
  }

  getSpinnerHTML() {
    // Récupérer la langue depuis le document
    const lang = document.documentElement.lang || 'fr'

    const translations = {
      fr: "Recherche des points relais disponibles...",
      en: "Searching for available relay points...",
      es: "Búsqueda de puntos de recogida disponibles...",
      it: "Ricerca dei punti di ritiro disponibili...",
      de: "Verfügbare Paketshops werden gesucht..."
    }

    const loadingText = translations[lang] || translations['fr']

    return `
      <turbo-frame id="relay_points_modal">
        <div class="fixed inset-0 z-50 overflow-y-auto">
          <div class="flex min-h-screen items-center justify-center p-4">
            <div class="fixed inset-0 bg-black bg-opacity-60 transition-opacity"></div>
            <div class="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all sm:w-full sm:max-w-md">
              <div class="flex flex-col items-center justify-center p-12">
                <div class="relative">
                  <div class="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600"></div>
                  <img src="${this.logoUrlValue}"
                       class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-8 w-auto object-contain"
                       alt="Chronopost">
                </div>
                <p class="mt-6 text-gray-600 text-center">${loadingText}</p>
              </div>
            </div>
          </div>
        </div>
      </turbo-frame>
    `
  }
}
